export const data = [
  {
    role: "Nurse",
    basicInfo: {
      name: "Mr. Ranjith",
    },
    dob: "2000-09-09",
    addressInfo: {
      city: "Chennai",
    },
    contactInfo: {
      phone: "917575757575",
    },
  },
  {
    role: "Physiotherapist",
    basicInfo: {
      name: "Dr. Anjali",
    },
    dob: "2000-09-09",
    addressInfo: {
      city: "Bangalore",
    },
    contactInfo: {
      phone: "919898989898",
    },
  },
];
export const Appledata = [
  { month: "June 1", download: [1, 1] },
  { month: "June 2", download: [75, 40] },
  { month: "June 3", download: [100, 50] },
  { month: "June 4", download: [200, 150] },
  { month: "June 5", download: [150, 100] },
  { month: "June 6", download: [80, 60] },
  { month: "June 7", download: [220, 180] },
  { month: "June 8", download: [60, 40] },
  { month: "June 9", download: [90, 50] },
  { month: "June 10", download: [180, 140] },
  { month: "June 11", download: [200, 160] },
  { month: "June 12", download: [120, 100] },
  { month: "June 13", download: [250, 200] },
  { month: "June 14", download: [140, 100] },
  { month: "June 15", download: [200, 150] },
  { month: "June 16", download: [100, 70] },
  { month: "June 17", download: [230, 180] },
  { month: "June 18", download: [60, 40] },
  { month: "June 19", download: [40, 20] },
  { month: "June 20", download: [70, 50] },
  { month: "June 21", download: [90, 60] },
  { month: "June 22", download: [200, 150] },
  { month: "June 23", download: [210, 170] },
  { month: "June 24", download: [1, 7] },
  { month: "June 25", download: [250, 200] },
  { month: "June 26", download: [80, 60] },
  { month: "June 27", download: [90, 70] },
  { month: "June 28", download: [180, 140] },
  { month: "June 29", download: [210, 170] },
  { month: "June 30", download: [100, 80] },
  { month: "June 31", download: [200, 20] },
];

export const PlayStoredata = [
  { month: "June 1", download: [4, 3] },
  { month: "June 2", download: [75, 40] },
  { month: "June 3", download: [100, 50] },
  { month: "June 4", download: [200, 150] },
  { month: "June 5", download: [150, 100] },
  { month: "June 6", download: [80, 60] },
  { month: "June 7", download: [220, 180] },
  { month: "June 8", download: [60, 40] },
  { month: "June 9", download: [90, 50] },
  { month: "June 10", download: [180, 140] },
  { month: "June 11", download: [200, 160] },
  { month: "June 12", download: [120, 100] },
  { month: "June 13", download: [250, 200] },
  { month: "June 14", download: [140, 100] },
  { month: "June 15", download: [200, 150] },
  { month: "June 16", download: [100, 70] },
  { month: "June 17", download: [230, 180] },
  { month: "June 18", download: [60, 40] },
  { month: "June 19", download: [40, 20] },
  { month: "June 20", download: [70, 50] },
  { month: "June 21", download: [90, 60] },
  { month: "June 22", download: [200, 150] },
  { month: "June 23", download: [210, 170] },
  { month: "June 24", download: [1, 7] },
  { month: "June 25", download: [250, 200] },
  { month: "June 26", download: [80, 60] },
  { month: "June 27", download: [90, 70] },
  { month: "June 28", download: [180, 140] },
  { month: "June 29", download: [210, 170] },
  { month: "June 30", download: [100, 80] },
  { month: "June 31", download: [200, 20] },
];

export const todayData = [
  { time: "00:00", download: [10, 5] },
  { time: "01:00", download: [15, 8] },
  { time: "02:00", download: [12, 7] },
  { time: "03:00", download: [14, 9] },
  { time: "04:00", download: [18, 11] },
  { time: "05:00", download: [20, 15] },
  { time: "06:00", download: [22, 18] },
  { time: "07:00", download: [25, 20] },
  { time: "08:00", download: [28, 22] },
  { time: "09:00", download: [30, 25] },
  { time: "10:00", download: [35, 28] },
  { time: "11:00", download: [40, 30] },
  { time: "12:00", download: [45, 35] },
  { time: "13:00", download: [50, 40] },
  { time: "14:00", download: [55, 45] },
  { time: "15:00", download: [60, 50] },
  { time: "16:00", download: [65, 55] },
  { time: "17:00", download: [70, 60] },
  { time: "18:00", download: [75, 65] },
  { time: "19:00", download: [80, 70] },
  { time: "20:00", download: [85, 75] },
  { time: "21:00", download: [90, 80] },
  { time: "22:00", download: [95, 85] },
  { time: "23:00", download: [100, 90] },
];

export const nurseData = [
  { date: "Jul 1", activeUsers: [10, 20] },
  { date: "Jul 2", activeUsers: [12, 18] },
  { date: "Jul 3", activeUsers: [14, 22] },
  { date: "Jul 4", activeUsers: [13, 20] },
  { date: "Jul 5", activeUsers: [15, 23] },
  { date: "Jul 6", activeUsers: [14, 21] },
  { date: "Jul 7", activeUsers: [16, 24] },
  { date: "Jul 8", activeUsers: [15, 22] },
  { date: "Jul 9", activeUsers: [17, 25] },
  { date: "Jul 10", activeUsers: [16, 23] },
  { date: "Jul 11", activeUsers: [18, 26] },
  { date: "Jul 12", activeUsers: [17, 24] },
  { date: "Jul 13", activeUsers: [19, 27] },
  { date: "Jul 14", activeUsers: [18, 25] },
  { date: "Jul 15", activeUsers: [20, 28] },
  { date: "Jul 16", activeUsers: [19, 26] },
  { date: "Jul 17", activeUsers: [21, 29] },
  { date: "Jul 18", activeUsers: [20, 27] },
  { date: "Jul 19", activeUsers: [22, 30] },
  { date: "Jul 20", activeUsers: [21, 28] },
  { date: "Jul 21", activeUsers: [23, 31] },
  { date: "Jul 22", activeUsers: [22, 29] },
  { date: "Jul 23", activeUsers: [24, 32] },
  { date: "Jul 24", activeUsers: [23, 30] },
  { date: "Jul 25", activeUsers: [25, 33] },
  { date: "Jul 26", activeUsers: [24, 31] },
  { date: "Jul 27", activeUsers: [26, 34] },
  { date: "Jul 28", activeUsers: [25, 32] },
  { date: "Jul 29", activeUsers: [27, 35] },
  { date: "Jul 30", activeUsers: [26, 33] },
];
export const patientData = [
  { date: "Jul 1", activeUsers: [70, 30] },
  { date: "Jul 2", activeUsers: [72, 28] },
  { date: "Jul 3", activeUsers: [74, 32] },
  { date: "Jul 4", activeUsers: [73, 30] },
  { date: "Jul 5", activeUsers: [75, 33] },
  { date: "Jul 6", activeUsers: [74, 31] },
  { date: "Jul 7", activeUsers: [76, 34] },
  { date: "Jul 8", activeUsers: [75, 32] },
  { date: "Jul 9", activeUsers: [77, 35] },
  { date: "Jul 10", activeUsers: [76, 33] },
  { date: "Jul 11", activeUsers: [78, 36] },
  { date: "Jul 12", activeUsers: [77, 34] },
  { date: "Jul 13", activeUsers: [79, 37] },
  { date: "Jul 14", activeUsers: [78, 35] },
  { date: "Jul 15", activeUsers: [80, 38] },
  { date: "Jul 16", activeUsers: [79, 36] },
  { date: "Jul 17", activeUsers: [81, 39] },
  { date: "Jul 18", activeUsers: [80, 37] },
  { date: "Jul 19", activeUsers: [82, 40] },
  { date: "Jul 20", activeUsers: [81, 38] },
  { date: "Jul 21", activeUsers: [83, 41] },
  { date: "Jul 22", activeUsers: [82, 39] },
  { date: "Jul 23", activeUsers: [84, 42] },
  { date: "Jul 24", activeUsers: [83, 40] },
  { date: "Jul 25", activeUsers: [85, 43] },
  { date: "Jul 26", activeUsers: [84, 41] },
  { date: "Jul 27", activeUsers: [86, 44] },
  { date: "Jul 28", activeUsers: [85, 42] },
  { date: "Jul 29", activeUsers: [87, 45] },
  { date: "Jul 30", activeUsers: [86, 43] },
];

// data.js
export const bookingsData = [
  { date: "Jun 1", bookings: 120 },
  { date: "Jun 2", bookings: 150 },
  { date: "Jun 3", bookings: 130 },
  { date: "Jun 4", bookings: 170 },
  { date: "Jun 5", bookings: 180 },
  { date: "Jun 6", bookings: 200 },
  { date: "Jun 7", bookings: 190 },
  { date: "Jun 8", bookings: 160 },
  { date: "Jun 9", bookings: 150 },
  { date: "Jun 10", bookings: 180 },
  { date: "Jun 11", bookings: 170 },
  { date: "Jun 12", bookings: 160 },
  { date: "Jun 13", bookings: 150 },
  { date: "Jun 14", bookings: 140 },
  { date: "Jun 15", bookings: 170 },
  { date: "Jun 16", bookings: 174 },
  { date: "Jun 17", bookings: 180 },
  { date: "Jun 18", bookings: 190 },
  { date: "Jun 19", bookings: 200 },
  { date: "Jun 20", bookings: 210 },
  { date: "Jun 21", bookings: 220 },
  { date: "Jun 22", bookings: 230 },
  { date: "Jun 23", bookings: 240 },
  { date: "Jun 24", bookings: 250 },
  { date: "Jun 25", bookings: 260 },
  { date: "Jun 26", bookings: 270 },
  { date: "Jun 27", bookings: 280 },
  { date: "Jun 28", bookings: 290 },
  { date: "Jun 29", bookings: 300 },
  { date: "Jun 30", bookings: 310 },
];

export const patientAgeData = [
  { ageGroup: "13-17", count: 5 },
  { ageGroup: "18-24", count: 20 },
  { ageGroup: "25-34", count: 45 },
  { ageGroup: "35-44", count: 50 },
  { ageGroup: "45-54", count: 40 },
  { ageGroup: "55-64", count: 15 },
  { ageGroup: "64+", count: 10 },
];

export const usersAgeData = [
  { role: "nurse", age: 28, gender: "female" },
  { role: "patient", age: 34, gender: "male" },
  { role: "physiotherapist", age: 30, gender: "female" },
  { role: "nurse", age: 26, gender: "male" },
  { role: "patient", age: 45, gender: "female" },
  { role: "physiotherapist", age: 40, gender: "male" },
  { role: "nurse", age: 32, gender: "female" },
  { role: "patient", age: 29, gender: "male" },
  { role: "physiotherapist", age: 35, gender: "female" },
  { role: "nurse", age: 27, gender: "female" },
  { role: "patient", age: 52, gender: "male" },
  { role: "physiotherapist", age: 37, gender: "male" },
  { role: "nurse", age: 31, gender: "male" },
  { role: "patient", age: 39, gender: "female" },
  { role: "physiotherapist", age: 33, gender: "female" },
];
